import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { TextSup } from '../../atoms';
import { Footnote } from '../../molecules';
import { FundTableLayout } from '../fund-table-layout';
import { getColumns } from './utils';
import { FundPerformanceInSelect, PerformanceSettings, } from '../fund-performance-in-select';
export default function ComponentWeb({ rowData, subTitle, trackPerformanceInClicked, onRowPress, }) {
    /**
     * State
     */
    const [performanceIn, setPerformanceIn] = useState(PerformanceSettings.ASSET_ACCUMULATION);
    /**
     * DOM
     */
    const columns = useMemo(() => getColumns(performanceIn), [performanceIn]);
    if (!(rowData === null || rowData === void 0 ? void 0 : rowData.length)) {
        return null;
    }
    return (_jsx(_Fragment, { children: _jsx(FundTableLayout, { title: "Your holdings*", subtitle: subTitle, header: _jsx(FundPerformanceInSelect, { performanceIn: performanceIn, setPerformanceIn: setPerformanceIn, trackPerformanceInClicked: trackPerformanceInClicked }), data: rowData, columns: columns, onRowPressed: onRowPress, children: _jsxs(Footnote, { children: ["Holdings and performance for month N are expected to update on or around the 10th of month N+1.", _jsx(TextSup, { children: "*" }), "Investor performance shown here may differ from fund-level returns, as it's calculated using the Money-Weighted Return (MWR) method based on varying individual subscription and redemption timings."] }) }) }));
}
